{
    "v": "5.9.0",
    "fr": 23.976,
    "ip": 0,
    "op": 72,
    "w": 1806,
    "h": 300,
    "nm": "Get to done...",
    "assets": [],
    "fonts": {
        "list": [
            {
                "fName": "CharlieDisplay-Black",
                "fFamily": "Charlie Display",
                "fStyle": "Black",
                "ascent": 70.9
            },
            {
                "fName": "AtlassianSans-Bold",
                "fFamily": "Atlassian Sans",
                "fStyle": "Bold",
                "ascent": 72.754
            }
        ]
    },
    "layers": [
        {
            "ind": 1,
            "ty": 3,
            "nm": "Master nudge Null",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0 },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [879, 170, 0], "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 2,
            "ty": 4,
            "nm": "Check.svg",
            "cl": "svg",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100 },
                "r": { "a": 0, "k": 14 },
                "p": { "a": 0, "k": [-227.25, -100.75, 0], "l": 2 },
                "a": { "a": 0, "k": [15.5, 14, 0], "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "l": 2 }
            },
            "ao": 0,
            "hasMask": true,
            "masksProperties": [
                {
                    "inv": false,
                    "mode": "a",
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 33,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [5.236, 5.126],
                                            [-1.335, -0.006],
                                            [-7.381, 9.16],
                                            [-9.046, 11.659],
                                            [-7.65, 14.385],
                                            [-5.964, 16.127],
                                            [-5.507, 14.021],
                                            [-3.476, 13.134],
                                            [5.859, 7.679]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 34.5,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.597, 12.696],
                                            [3.026, 7.564],
                                            [-3.02, 16.73],
                                            [-4.685, 19.229],
                                            [-3.289, 21.955],
                                            [-1.603, 23.697],
                                            [-1.146, 21.591],
                                            [0.885, 20.704],
                                            [10.22, 15.249]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 36,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.597, 12.696],
                                            [3.026, 7.564],
                                            [-3.02, 16.73],
                                            [5.38, 27.85],
                                            [11.083, 31.976],
                                            [13.586, 30.052],
                                            [15.672, 28.528],
                                            [18.402, 26.478],
                                            [10.22, 15.249]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 39,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.597, 12.696],
                                            [3.026, 7.564],
                                            [-3.02, 16.73],
                                            [5.38, 27.85],
                                            [11.083, 31.976],
                                            [20.46, 22.896],
                                            [27.208, 12.295],
                                            [35.414, 3.438],
                                            [25.541, -3.66]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 60.25,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.597, 12.696],
                                            [3.026, 7.564],
                                            [-3.02, 16.73],
                                            [5.38, 27.85],
                                            [11.083, 31.976],
                                            [20.46, 22.896],
                                            [27.208, 12.295],
                                            [35.414, 3.438],
                                            [25.541, -3.66]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 61.5,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.597, 12.696],
                                            [8.36, 13.613],
                                            [2.314, 22.779],
                                            [5.38, 27.85],
                                            [11.083, 31.976],
                                            [20.46, 22.896],
                                            [27.208, 12.295],
                                            [35.414, 3.438],
                                            [25.541, -3.66]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 62.75,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.597, 12.696],
                                            [8.36, 13.613],
                                            [16.525, 24.974],
                                            [19.591, 30.046],
                                            [22.405, 25.874],
                                            [29.338, 17.95],
                                            [33.126, 10.82],
                                            [35.414, 3.438],
                                            [25.541, -3.66]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 64,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [18.865, 0.547],
                                            [16.599, 2.814],
                                            [28.496, 11.605],
                                            [31.562, 16.677],
                                            [34.376, 12.504],
                                            [34.679, 11.972],
                                            [36.665, 7.478],
                                            [35.414, 3.438],
                                            [25.541, -3.66]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "t": 65.25,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [24.98, -7.81],
                                            [22.714, -5.543],
                                            [34.611, 3.249],
                                            [37.677, 8.32],
                                            [40.491, 4.148],
                                            [40.794, 3.616],
                                            [42.78, -0.879],
                                            [41.529, -4.919],
                                            [31.656, -12.016]
                                        ],
                                        "c": true
                                    }
                                ]
                            }
                        ]
                    },
                    "o": { "a": 0, "k": 100 },
                    "x": { "a": 0, "k": 0 },
                    "nm": "Mask 1"
                }
            ],
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [-0.61, -0.89],
                                        [-1.38, -1.39],
                                        [-0.54, -0.33],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-0.19, -0.19],
                                        [-0.41, -0.59],
                                        [-1.1, -1.73],
                                        [-1.01, 1.38],
                                        [-0.47, 0.58],
                                        [-0.12, 0.12],
                                        [-0.07, 0.07],
                                        [-0.08, 0.14],
                                        [-3.08, 3.04],
                                        [-0.7, 0.68],
                                        [-0.91, 1.59],
                                        [0.98, -0.37],
                                        [1.8, -1.7],
                                        [2.04, -2.03],
                                        [0.21, -0.44],
                                        [1.02, -1.46],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0.16, -0.21],
                                        [0.19, 0.22],
                                        [0.1, 0.11],
                                        [0.24, 0.26],
                                        [0.26, 0.26],
                                        [1.6, 0.59]
                                    ],
                                    "o": [
                                        [-1.15, -0.42],
                                        [0.87, 1.29],
                                        [0.84, 0.72],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0.2, 0.17],
                                        [0.38, 0.37],
                                        [0.81, 1.09],
                                        [1.14, -1.55],
                                        [0.55, -0.76],
                                        [0.28, -0.35],
                                        [0.1, -0.1],
                                        [0.12, -0.11],
                                        [0.5, -1.01],
                                        [2.02, -2.26],
                                        [1.65, -1.62],
                                        [0.5, -0.87],
                                        [-1.79, 0.66],
                                        [-0.7, 0.66],
                                        [-0.33, 0.33],
                                        [-0.91, 1.85],
                                        [-1.02, 1.45],
                                        [0, 0],
                                        [0, 0],
                                        [-0.18, 0.26],
                                        [-0.17, -0.24],
                                        [-0.12, -0.14],
                                        [-0.32, -0.35],
                                        [-0.49, -0.51],
                                        [-1.62, -1.56],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-12.57, -1.04],
                                        [-15.02, 2.18],
                                        [-11.77, 6.03],
                                        [-9.76, 7.45],
                                        [-9.66, 7.51],
                                        [-9.51, 7.63],
                                        [-9.2, 7.89],
                                        [-8.62, 8.43],
                                        [-7.46, 9.8],
                                        [-4.58, 14.09],
                                        [-1.23, 9.53],
                                        [0.34, 7.5],
                                        [0.8, 6.99],
                                        [1.06, 6.73],
                                        [1.35, 6.35],
                                        [7.43, -2.08],
                                        [11.5, -6.34],
                                        [15.13, -10.95],
                                        [12.82, -13.72],
                                        [7.6, -10.38],
                                        [2.86, -6.84],
                                        [2.05, -5.69],
                                        [-1.15, -0.49],
                                        [-2.97, 1.97],
                                        [-4.04, 3.53],
                                        [-4.54, 4.29],
                                        [-5.05, 5.09],
                                        [-5.58, 4.4],
                                        [-5.91, 4.03],
                                        [-6.75, 3.12],
                                        [-7.85, 2.01],
                                        [-12.6, -1.06]
                                    ],
                                    "c": true
                                }
                            },
                            "nm": "Path 1"
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.063, 0.071, 0.078, 1] },
                            "o": { "a": 0, "k": 100 },
                            "r": 1,
                            "nm": "Fill 1"
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [15.137, 13.76] },
                            "a": { "a": 0, "k": [0, 0] },
                            "s": { "a": 0, "k": [100, 100] },
                            "r": { "a": 0, "k": 0 },
                            "o": { "a": 0, "k": 100 },
                            "sk": { "a": 0, "k": 0 },
                            "sa": { "a": 0, "k": 0 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1"
                }
            ],
            "ip": 24,
            "op": 72,
            "st": 26
        },
        {
            "ind": 3,
            "ty": 4,
            "nm": "Circle.svg",
            "cl": "svg",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100 },
                "r": { "a": 0, "k": 14 },
                "p": { "a": 0, "k": [-225.5, -98.5, 0], "l": 2 },
                "a": { "a": 0, "k": [48.5, 47.5, 0], "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "l": 2 }
            },
            "ao": 0,
            "hasMask": true,
            "masksProperties": [
                {
                    "inv": false,
                    "mode": "a",
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 37,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [46.187, 16.528],
                                            [29.147, 20.949],
                                            [18.6, 29.033],
                                            [12.775, 49.267],
                                            [17.066, 67.746],
                                            [26.385, 79.18],
                                            [37.695, 81.699],
                                            [54.523, 83.562],
                                            [58.514, 81.57],
                                            [66.318, 73.642],
                                            [79.177, 58.803],
                                            [85.876, 46.912],
                                            [86.629, 29.269],
                                            [84.356, 18.811],
                                            [83.551, 26.248],
                                            [82.982, 31.5],
                                            [82.651, 34.558],
                                            [64.369, 21.916]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 38.2,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [46.187, 16.528],
                                            [29.147, 20.949],
                                            [18.6, 29.033],
                                            [12.775, 49.267],
                                            [17.066, 67.746],
                                            [26.385, 79.18],
                                            [37.695, 81.699],
                                            [54.523, 83.562],
                                            [58.514, 81.57],
                                            [66.318, 73.642],
                                            [79.177, 58.803],
                                            [85.876, 46.912],
                                            [86.629, 29.269],
                                            [84.356, 18.811],
                                            [79.247, 13.414],
                                            [75.64, 9.603],
                                            [73.539, 7.384],
                                            [64.369, 21.916]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 39.4,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.55, -1.416],
                                            [29.147, 20.949],
                                            [18.6, 29.033],
                                            [12.775, 49.267],
                                            [17.066, 67.746],
                                            [26.385, 79.18],
                                            [37.695, 81.699],
                                            [54.523, 83.562],
                                            [58.514, 81.57],
                                            [66.318, 73.642],
                                            [79.177, 58.803],
                                            [85.876, 46.912],
                                            [86.629, 29.269],
                                            [84.356, 18.811],
                                            [79.247, 13.414],
                                            [75.64, 9.603],
                                            [73.539, 7.384],
                                            [56.577, -5.587]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 40.6,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.55, -1.416],
                                            [4.069, 19.724],
                                            [-5.281, 47.607],
                                            [0, 74.888],
                                            [10.122, 90.51],
                                            [25.604, 96.669],
                                            [37.695, 81.699],
                                            [54.523, 83.562],
                                            [58.514, 81.57],
                                            [66.318, 73.642],
                                            [79.177, 58.803],
                                            [85.876, 46.912],
                                            [86.629, 29.269],
                                            [84.356, 18.811],
                                            [79.247, 13.414],
                                            [75.64, 9.603],
                                            [73.539, 7.384],
                                            [56.577, -5.587]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.667, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 41.8,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.55, -1.416],
                                            [4.069, 19.724],
                                            [-5.281, 47.607],
                                            [0, 74.888],
                                            [10.122, 90.51],
                                            [25.604, 96.669],
                                            [48.683, 99.525],
                                            [73.987, 92.264],
                                            [87.331, 84.668],
                                            [94.914, 77.729],
                                            [103.38, 52.768],
                                            [85.876, 46.912],
                                            [86.629, 29.269],
                                            [84.356, 18.811],
                                            [79.247, 13.414],
                                            [75.64, 9.603],
                                            [73.539, 7.384],
                                            [56.577, -5.587]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.333, "y": 0 },
                                "t": 43,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.55, -1.416],
                                            [4.069, 19.724],
                                            [-5.281, 47.607],
                                            [0, 74.888],
                                            [10.122, 90.51],
                                            [25.604, 96.669],
                                            [48.683, 99.525],
                                            [73.987, 92.264],
                                            [87.331, 84.668],
                                            [94.914, 77.729],
                                            [103.38, 52.768],
                                            [96.894, 17.991],
                                            [89.392, 8.482],
                                            [79.2, -1.871],
                                            [76.526, 2.5],
                                            [74.638, 5.587],
                                            [73.539, 7.384],
                                            [56.577, -5.587]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 64,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.55, -1.416],
                                            [4.069, 19.724],
                                            [-5.281, 47.607],
                                            [0, 74.888],
                                            [10.122, 90.51],
                                            [25.604, 96.669],
                                            [48.683, 99.525],
                                            [73.987, 92.264],
                                            [87.331, 84.668],
                                            [94.914, 77.729],
                                            [103.38, 52.768],
                                            [96.894, 17.991],
                                            [89.392, 8.482],
                                            [79.2, -1.871],
                                            [76.526, 2.5],
                                            [74.638, 5.587],
                                            [73.539, 7.384],
                                            [56.577, -5.587]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 65.4,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.55, -1.416],
                                            [4.069, 19.724],
                                            [-5.281, 47.607],
                                            [0, 74.888],
                                            [10.122, 90.51],
                                            [25.604, 96.669],
                                            [48.683, 99.525],
                                            [73.987, 92.264],
                                            [87.331, 84.668],
                                            [94.914, 77.729],
                                            [103.38, 52.768],
                                            [96.894, 17.991],
                                            [89.392, 8.482],
                                            [79.2, -1.871],
                                            [75.74, 5.628],
                                            [84.344, 30.908],
                                            [63.847, 26.627],
                                            [31.267, 12.876]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 66.8,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [23.305, 22.233],
                                            [13.071, 46.458],
                                            [16.707, 64.56],
                                            [23.759, 74.573],
                                            [32.349, 78.425],
                                            [25.604, 96.669],
                                            [48.683, 99.525],
                                            [73.987, 92.264],
                                            [87.331, 84.668],
                                            [94.914, 77.729],
                                            [103.38, 52.768],
                                            [96.894, 17.991],
                                            [89.392, 8.482],
                                            [79.2, -1.871],
                                            [75.74, 5.628],
                                            [84.344, 30.908],
                                            [63.847, 26.627],
                                            [31.267, 12.876]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 68.2,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [23.305, 22.233],
                                            [13.071, 46.458],
                                            [16.707, 64.56],
                                            [23.759, 74.573],
                                            [32.349, 78.425],
                                            [45.742, 81.832],
                                            [62.007, 76.105],
                                            [72.571, 69.714],
                                            [79.755, 61.785],
                                            [84.483, 49.014],
                                            [103.38, 52.768],
                                            [96.894, 17.991],
                                            [89.392, 8.482],
                                            [79.2, -1.871],
                                            [75.74, 5.628],
                                            [84.344, 30.908],
                                            [63.847, 26.627],
                                            [31.267, 12.876]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 1 },
                                "o": { "x": 0.167, "y": 0 },
                                "t": 69.6,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [23.305, 22.233],
                                            [13.071, 46.458],
                                            [16.707, 64.56],
                                            [23.759, 74.573],
                                            [32.349, 78.425],
                                            [45.742, 81.832],
                                            [62.007, 76.105],
                                            [72.571, 69.714],
                                            [79.755, 61.785],
                                            [84.483, 49.014],
                                            [83.809, 39.886],
                                            [82.705, 17.322],
                                            [92.03, 11.563],
                                            [79.2, -1.871],
                                            [75.74, 5.628],
                                            [84.344, 30.908],
                                            [63.847, 26.627],
                                            [31.267, 12.876]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "t": 71,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [23.305, 22.233],
                                            [13.071, 46.458],
                                            [16.707, 64.56],
                                            [23.759, 74.573],
                                            [32.349, 78.425],
                                            [45.742, 81.832],
                                            [62.007, 76.105],
                                            [72.571, 69.714],
                                            [79.755, 61.785],
                                            [84.483, 49.014],
                                            [83.809, 39.886],
                                            [82.705, 17.322],
                                            [76.083, 7.593],
                                            [79.2, -1.871],
                                            [75.74, 5.628],
                                            [84.344, 30.908],
                                            [63.847, 26.627],
                                            [31.267, 12.876]
                                        ],
                                        "c": true
                                    }
                                ]
                            }
                        ]
                    },
                    "o": { "a": 0, "k": 100 },
                    "x": { "a": 0, "k": 0 },
                    "nm": "Mask 1"
                }
            ],
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [-0.27, -0.3],
                                        [-0.23, -0.26],
                                        [-0.39, -0.31],
                                        [-0.42, 0.21],
                                        [0.17, 1.03],
                                        [0.26, 0.71],
                                        [0.2, 0.4],
                                        [0.27, 0.42],
                                        [5.23, 3.68],
                                        [7.82, 1.06],
                                        [3.09, -0.65],
                                        [0.7, -0.24],
                                        [0.65, -0.2],
                                        [1.13, -0.49],
                                        [4.27, -4.08],
                                        [0.91, -0.98],
                                        [0.82, -1.16],
                                        [1.38, -2.69],
                                        [0.98, -2.91],
                                        [0.51, -2.9],
                                        [-0.57, -4.63],
                                        [-0.72, -1.95],
                                        [-0.24, -0.57],
                                        [0, 0],
                                        [-3.82, -3.91],
                                        [-2.79, -1.74],
                                        [-3.49, -1.22],
                                        [-8.21, 1.05],
                                        [-3.88, 1.37],
                                        [-0.96, 0.37],
                                        [-0.92, 0.48],
                                        [-0.92, 0.46],
                                        [-0.89, 0.51],
                                        [-2.97, 3.71],
                                        [-1.49, 3.4],
                                        [-0.34, 3.68],
                                        [0.46, 3.84],
                                        [1.07, 3.35],
                                        [4.5, 4.78],
                                        [0.54, 0.4],
                                        [0.45, 0.16],
                                        [0.25, -0.33],
                                        [-0.41, -0.76],
                                        [-0.33, -0.52],
                                        [-0.45, -0.66],
                                        [-1.65, -6.21],
                                        [-0.33, -3.53],
                                        [0.36, -3.94],
                                        [2.46, -5.61],
                                        [2.29, -2.93],
                                        [3.57, -2.54],
                                        [2.52, -1.38],
                                        [1.47, -0.67],
                                        [1.57, -0.46],
                                        [3.26, -0.29],
                                        [1.62, -0.01],
                                        [1.54, 0.24],
                                        [2.63, 0.98],
                                        [2.51, 2.26],
                                        [0.48, 0.45],
                                        [0.31, 0.34],
                                        [0.14, 0.19],
                                        [0, 0],
                                        [0.21, 0.27],
                                        [0.38, 0.55],
                                        [0.49, 0.81],
                                        [0.49, 1.1],
                                        [-0.01, 7.4],
                                        [-0.81, 3.8],
                                        [-1.57, 3.39],
                                        [-1.99, 2.61],
                                        [-1.92, 1.66],
                                        [-2.59, 1.19],
                                        [-0.61, 0.25],
                                        [-0.58, 0.19],
                                        [-0.55, 0.14],
                                        [-0.52, 0.09],
                                        [-2.22, -0.32],
                                        [-4.79, -3.05],
                                        [-3.13, -4.13]
                                    ],
                                    "o": [
                                        [0.28, 0.36],
                                        [0.25, 0.32],
                                        [0.45, 0.53],
                                        [0.78, 0.63],
                                        [0.42, -0.21],
                                        [-0.08, -0.52],
                                        [-0.14, -0.35],
                                        [-0.21, -0.38],
                                        [-3, -4.82],
                                        [-5.22, -3.65],
                                        [-4.42, -0.52],
                                        [-0.77, 0.17],
                                        [-0.7, 0.22],
                                        [-1.32, 0.35],
                                        [-4.34, 2.17],
                                        [-0.91, 0.85],
                                        [-0.85, 1.04],
                                        [-1.68, 2.27],
                                        [-1.39, 2.68],
                                        [-1, 2.91],
                                        [-1.03, 5.84],
                                        [0.55, 4.65],
                                        [0.22, 0.58],
                                        [0, 0],
                                        [1.03, 1.95],
                                        [1.93, 1.92],
                                        [2.78, 1.75],
                                        [6.96, 2.49],
                                        [4.1, -0.51],
                                        [0.99, -0.29],
                                        [0.95, -0.41],
                                        [0.93, -0.46],
                                        [0.93, -0.44],
                                        [4.92, -3.05],
                                        [2.98, -3.71],
                                        [2.82, -6.89],
                                        [0.39, -4.36],
                                        [-0.45, -3.84],
                                        [-2.14, -6.66],
                                        [-0.58, -0.68],
                                        [-0.54, -0.41],
                                        [-0.9, -0.32],
                                        [-0.25, 0.33],
                                        [0.21, 0.38],
                                        [0.33, 0.52],
                                        [3.51, 4.59],
                                        [0.83, 3.11],
                                        [0.33, 3.52],
                                        [-0.27, 3.05],
                                        [-1.27, 2.78],
                                        [-2.3, 2.92],
                                        [-2.29, 1.7],
                                        [-1.37, 0.72],
                                        [-1.52, 0.53],
                                        [-3.13, 0.99],
                                        [-1.63, 0.16],
                                        [-1.61, -0.09],
                                        [-3.09, -0.44],
                                        [-5.27, -1.93],
                                        [-0.62, -0.58],
                                        [-0.45, -0.49],
                                        [-0.31, -0.34],
                                        [-0.15, -0.19],
                                        [0, 0],
                                        [-0.21, -0.28],
                                        [-0.37, -0.56],
                                        [-0.46, -0.83],
                                        [-2.2, -4.25],
                                        [-0.01, -3.69],
                                        [0.81, -3.77],
                                        [1.57, -3.39],
                                        [1.99, -2.62],
                                        [2.89, -2.49],
                                        [0.65, -0.27],
                                        [0.59, -0.28],
                                        [0.59, -0.16],
                                        [0.56, -0.09],
                                        [4.19, -0.61],
                                        [6.78, 0.89],
                                        [4.8, 3.08],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [27.375, -24.39],
                                        [28.205, -23.4],
                                        [28.905, -22.52],
                                        [30.175, -21.25],
                                        [32.025, -20.63],
                                        [32.445, -22.5],
                                        [31.935, -24.35],
                                        [31.455, -25.49],
                                        [30.725, -26.69],
                                        [18.455, -39.61],
                                        [-1.015, -47.35],
                                        [-12.215, -47.06],
                                        [-14.435, -46.58],
                                        [-16.455, -45.95],
                                        [-20.035, -44.47],
                                        [-31.955, -35.82],
                                        [-34.615, -33],
                                        [-37.185, -29.76],
                                        [-41.835, -22.29],
                                        [-45.415, -13.86],
                                        [-47.595, -5.04],
                                        [-48.045, 11.11],
                                        [-45.605, 21.29],
                                        [-44.925, 23.02],
                                        [-44.105, 24.7],
                                        [-37.205, 34.22],
                                        [-30.165, 39.89],
                                        [-20.725, 44.44],
                                        [2.695, 46.82],
                                        [14.775, 43.94],
                                        [17.675, 42.84],
                                        [20.525, 41.63],
                                        [23.295, 40.25],
                                        [25.965, 38.7],
                                        [37.785, 28.31],
                                        [44.305, 17.47],
                                        [48.235, 1.45],
                                        [48.025, -10.86],
                                        [45.715, -21.63],
                                        [36.075, -38.96],
                                        [34.285, -40.51],
                                        [32.755, -41.33],
                                        [31.035, -41.26],
                                        [31.285, -39.58],
                                        [32.105, -38.27],
                                        [33.345, -36.6],
                                        [40.845, -20.23],
                                        [42.605, -10.28],
                                        [42.645, 0.92],
                                        [39.045, 14.32],
                                        [33.845, 23.03],
                                        [25.075, 31.35],
                                        [17.765, 35.85],
                                        [13.455, 37.86],
                                        [8.825, 39.48],
                                        [-0.855, 41.32],
                                        [-5.735, 41.48],
                                        [-10.475, 41.07],
                                        [-19.135, 38.96],
                                        [-30.975, 32.06],
                                        [-32.625, 30.51],
                                        [-33.765, 29.26],
                                        [-34.455, 28.47],
                                        [-34.675, 28.18],
                                        [-35.005, 27.76],
                                        [-35.945, 26.54],
                                        [-37.295, 24.51],
                                        [-38.845, 21.67],
                                        [-42.875, 3.45],
                                        [-41.665, -7.9],
                                        [-38.005, -18.75],
                                        [-32.555, -27.84],
                                        [-26.535, -34.25],
                                        [-18.185, -39.69],
                                        [-16.305, -40.47],
                                        [-14.495, -41.03],
                                        [-12.795, -41.5],
                                        [-11.165, -41.76],
                                        [-1.765, -41.81],
                                        [15.565, -35.33],
                                        [27.385, -24.43]
                                    ],
                                    "c": true
                                }
                            },
                            "nm": "Path 1"
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.063, 0.071, 0.078, 1] },
                            "o": { "a": 0, "k": 100 },
                            "r": 1,
                            "nm": "Fill 1"
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [48.432, 47.66] },
                            "a": { "a": 0, "k": [0, 0] },
                            "s": { "a": 0, "k": [100, 100] },
                            "r": { "a": 0, "k": 0 },
                            "o": { "a": 0, "k": 100 },
                            "sk": { "a": 0, "k": 0 },
                            "sa": { "a": 0, "k": 0 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1"
                }
            ],
            "ip": 24,
            "op": 72,
            "st": 26
        },
        {
            "ind": 4,
            "ty": 4,
            "nm": "Eyelash c.svg",
            "cl": "svg",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100 },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [-215.5, 59.5, 0], "l": 2 },
                "a": { "a": 0, "k": [36.5, 23.5, 0], "l": 2 },
                "s": { "a": 0, "k": [100, -100, 100], "l": 2 }
            },
            "ao": 0,
            "hasMask": true,
            "masksProperties": [
                {
                    "inv": false,
                    "mode": "a",
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": 0.833, "y": 0.833 },
                                "o": { "x": 0.167, "y": 0.167 },
                                "t": 1,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [1.331, 32.886],
                                            [-4.661, 25.225],
                                            [-8.29, 18.929],
                                            [-6.783, 33.162],
                                            [15.699, 42.959],
                                            [32.279, 49.742],
                                            [46.599, 56.525],
                                            [67.609, 58.786],
                                            [58.93, 52.786],
                                            [54.37, 50.395],
                                            [45.25, 48.555],
                                            [41.41, 45.016],
                                            [35.276, 43.096],
                                            [23.495, 38.056],
                                            [10.553, 33.976]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 0.833 },
                                "o": { "x": 0.167, "y": 0.167 },
                                "t": 4,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.044, -8.29],
                                            [-1.507, -9.71],
                                            [-7.536, 15.914],
                                            [-6.029, 30.147],
                                            [16.452, 39.945],
                                            [33.033, 46.728],
                                            [47.353, 53.511],
                                            [68.362, 55.772],
                                            [72.884, 37.771],
                                            [72.884, 27.219],
                                            [72.884, 12.9],
                                            [72.884, 0],
                                            [57.15, 0],
                                            [40.57, 0],
                                            [19.467, 0]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "t": 7,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.044, -8.29],
                                            [-1.507, -9.71],
                                            [-2.496, -3.286],
                                            [11.732, -2.254],
                                            [51.013, 7.544],
                                            [59.434, 27.767],
                                            [75.434, 29.99],
                                            [68.362, 55.772],
                                            [72.884, 37.771],
                                            [72.884, 27.219],
                                            [72.884, 12.9],
                                            [72.884, 0],
                                            [57.15, 0],
                                            [40.57, 0],
                                            [19.467, 0]
                                        ],
                                        "c": true
                                    }
                                ]
                            }
                        ]
                    },
                    "o": { "a": 0, "k": 100 },
                    "x": { "a": 0, "k": 0 },
                    "nm": "Mask 1"
                }
            ],
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0.79, 0.04],
                                        [1.63, -0.66],
                                        [1.91, -0.65],
                                        [0.25, -0.25],
                                        [0, 0],
                                        [2.101, -0.886],
                                        [0.47, -0.2],
                                        [0.86, -0.9],
                                        [0, 0],
                                        [-0.88, -0.01],
                                        [-1.43, 0.58],
                                        [-1.12, 0.39],
                                        [-0.84, 0.11],
                                        [-0.1, 0.07],
                                        [-3.1, 1.05],
                                        [-0.68, 0.29],
                                        [-0.94, 1.09]
                                    ],
                                    "o": [
                                        [-1.44, -0.08],
                                        [-0.63, 0.26],
                                        [-0.31, 0.11],
                                        [-2.16, 2.09],
                                        [-0.044, 0.019],
                                        [-1.59, 0.68],
                                        [-1.41, 0.62],
                                        [0, 0],
                                        [-0.61, 0.64],
                                        [1.25, 0.01],
                                        [1.55, -0.83],
                                        [1.84, -0.78],
                                        [0.12, -0.02],
                                        [0.75, -0.45],
                                        [2.12, -0.91],
                                        [1.61, -0.71],
                                        [0.52, -0.6]
                                    ],
                                    "v": [
                                        [34.843, 7.929],
                                        [30.433, 8.699],
                                        [26.273, 9.429],
                                        [25.433, 9.959],
                                        [19.813, 13.189],
                                        [12.703, 16.179],
                                        [9.883, 17.389],
                                        [6.603, 19.629],
                                        [6.613, 19.629],
                                        [8.193, 23.359],
                                        [12.083, 22.569],
                                        [14.883, 20.539],
                                        [21.043, 19.189],
                                        [21.383, 19.069],
                                        [28.513, 15.629],
                                        [32.623, 13.87],
                                        [36.253, 11.249]
                                    ],
                                    "c": true
                                }
                            },
                            "nm": "Path 1"
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.063, 0.071, 0.078, 1] },
                            "o": { "a": 0, "k": 100 },
                            "r": 1,
                            "nm": "Fill 1"
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [36.5, 23.369] },
                            "a": { "a": 0, "k": [0, 0] },
                            "s": { "a": 0, "k": [100, 100] },
                            "r": { "a": 0, "k": 0 },
                            "o": { "a": 0, "k": 100 },
                            "sk": { "a": 0, "k": 0 },
                            "sa": { "a": 0, "k": 0 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1"
                }
            ],
            "ip": 1,
            "op": 8,
            "st": 0
        },
        {
            "ind": 5,
            "ty": 4,
            "nm": "Eyelash b.svg ",
            "cl": "svg",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100 },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [-215.5, 59.5, 0], "l": 2 },
                "a": { "a": 0, "k": [36.5, 23.5, 0], "l": 2 },
                "s": { "a": 0, "k": [100, -100, 100], "l": 2 }
            },
            "ao": 0,
            "hasMask": true,
            "masksProperties": [
                {
                    "inv": false,
                    "mode": "a",
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": 0.833, "y": 0.833 },
                                "o": { "x": 0.167, "y": 0.167 },
                                "t": 1,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [1.331, 32.886],
                                            [-4.661, 25.225],
                                            [-8.29, 18.929],
                                            [-6.783, 33.162],
                                            [15.699, 42.959],
                                            [32.279, 49.742],
                                            [46.599, 56.525],
                                            [67.609, 58.786],
                                            [58.93, 52.786],
                                            [54.37, 50.395],
                                            [45.25, 48.555],
                                            [41.41, 45.016],
                                            [35.276, 43.096],
                                            [23.495, 38.056],
                                            [10.553, 33.976]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 0.833 },
                                "o": { "x": 0.167, "y": 0.167 },
                                "t": 4,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.044, -8.29],
                                            [-1.507, -9.71],
                                            [-7.536, 15.914],
                                            [-6.029, 30.147],
                                            [16.452, 39.945],
                                            [33.033, 46.728],
                                            [47.353, 53.511],
                                            [68.362, 55.772],
                                            [72.884, 37.771],
                                            [72.884, 27.219],
                                            [72.884, 12.9],
                                            [72.884, 0],
                                            [57.15, 0],
                                            [40.57, 0],
                                            [19.467, 0]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "t": 7,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.044, -8.29],
                                            [-1.507, -9.71],
                                            [-2.496, -3.286],
                                            [11.732, -2.254],
                                            [51.013, 7.544],
                                            [59.434, 27.767],
                                            [75.434, 29.99],
                                            [68.362, 55.772],
                                            [72.884, 37.771],
                                            [72.884, 27.219],
                                            [72.884, 12.9],
                                            [72.884, 0],
                                            [57.15, 0],
                                            [40.57, 0],
                                            [19.467, 0]
                                        ],
                                        "c": true
                                    }
                                ]
                            }
                        ]
                    },
                    "o": { "a": 0, "k": 100 },
                    "x": { "a": 0, "k": 0 },
                    "nm": "Mask 1"
                }
            ],
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0.72, -0.329],
                                        [1.12, -1.35],
                                        [1.36, -1.479],
                                        [0.11, -0.33],
                                        [0.02, -0.021],
                                        [1.43, -1.78],
                                        [0.32, -0.4],
                                        [0.33, -1.2],
                                        [0, 0],
                                        [-0.78, 0.41],
                                        [-0.99, 1.19],
                                        [-0.81, 0.87],
                                        [-0.7, 0.49],
                                        [-0.07, 0.11],
                                        [-2.22, 2.39],
                                        [-0.46, 0.58],
                                        [-0.31, 1.41]
                                    ],
                                    "o": [
                                        [-1.3, 0.61],
                                        [-0.431, 0.53],
                                        [-0.22, 0.24],
                                        [-0.896, 2.858],
                                        [0, 0],
                                        [-1.07, 1.35],
                                        [-0.95, 1.22],
                                        [0, 0],
                                        [-0.23, 0.85],
                                        [1.1, -0.58],
                                        [0.97, -1.46],
                                        [1.25, -1.57],
                                        [0.1, -0.07],
                                        [0.44, -0.75],
                                        [1.43, -1.8],
                                        [1.08, -1.39],
                                        [0.169, -0.77]
                                    ],
                                    "v": [
                                        [6.693, -13.191],
                                        [3.183, -10.421],
                                        [-0.127, -7.801],
                                        [-0.617, -6.941],
                                        [-4.037, -1.431],
                                        [-8.877, 4.579],
                                        [-10.787, 6.979],
                                        [-12.607, 10.499],
                                        [-12.617, 10.509],
                                        [-9.457, 13.039],
                                        [-6.407, 10.499],
                                        [-4.897, 7.389],
                                        [-0.107, 3.279],
                                        [0.143, 3.009],
                                        [4.783, -3.401],
                                        [7.563, -6.901],
                                        [9.513, -10.931]
                                    ],
                                    "c": true
                                }
                            },
                            "nm": "Path 2"
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.063, 0.071, 0.078, 1] },
                            "o": { "a": 0, "k": 100 },
                            "r": 1,
                            "nm": "Fill 1"
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [36.5, 23.369] },
                            "a": { "a": 0, "k": [0, 0] },
                            "s": { "a": 0, "k": [100, 100] },
                            "r": { "a": 0, "k": 0 },
                            "o": { "a": 0, "k": 100 },
                            "sk": { "a": 0, "k": 0 },
                            "sa": { "a": 0, "k": 0 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1"
                }
            ],
            "ip": 1,
            "op": 8,
            "st": 0
        },
        {
            "ind": 6,
            "ty": 4,
            "nm": "Eyelash a.svg",
            "cl": "svg",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100 },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [-215.5, 59.5, 0], "l": 2 },
                "a": { "a": 0, "k": [36.5, 23.5, 0], "l": 2 },
                "s": { "a": 0, "k": [100, -100, 100], "l": 2 }
            },
            "ao": 0,
            "hasMask": true,
            "masksProperties": [
                {
                    "inv": false,
                    "mode": "a",
                    "pt": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": 0.833, "y": 0.833 },
                                "o": { "x": 0.167, "y": 0.167 },
                                "t": 1,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [1.331, 32.886],
                                            [-4.661, 25.225],
                                            [-8.29, 18.929],
                                            [-6.783, 33.162],
                                            [15.699, 42.959],
                                            [32.279, 49.742],
                                            [46.599, 56.525],
                                            [67.609, 58.786],
                                            [58.93, 52.786],
                                            [54.37, 50.395],
                                            [45.25, 48.555],
                                            [41.41, 45.016],
                                            [35.276, 43.096],
                                            [23.495, 38.056],
                                            [10.553, 33.976]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "i": { "x": 0.833, "y": 0.833 },
                                "o": { "x": 0.167, "y": 0.167 },
                                "t": 4,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.044, -8.29],
                                            [-1.507, -9.71],
                                            [-7.536, 15.914],
                                            [-6.029, 30.147],
                                            [16.452, 39.945],
                                            [33.033, 46.728],
                                            [47.353, 53.511],
                                            [68.362, 55.772],
                                            [72.884, 37.771],
                                            [72.884, 27.219],
                                            [72.884, 12.9],
                                            [72.884, 0],
                                            [57.15, 0],
                                            [40.57, 0],
                                            [19.467, 0]
                                        ],
                                        "c": true
                                    }
                                ]
                            },
                            {
                                "t": 7,
                                "s": [
                                    {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [9.044, -8.29],
                                            [-1.507, -9.71],
                                            [-2.496, -3.286],
                                            [11.732, -2.254],
                                            [51.013, 7.544],
                                            [59.434, 27.767],
                                            [75.434, 29.99],
                                            [68.362, 55.772],
                                            [72.884, 37.771],
                                            [72.884, 27.219],
                                            [72.884, 12.9],
                                            [72.884, 0],
                                            [57.15, 0],
                                            [40.57, 0],
                                            [19.467, 0]
                                        ],
                                        "c": true
                                    }
                                ]
                            }
                        ]
                    },
                    "o": { "a": 0, "k": 100 },
                    "x": { "a": 0, "k": 0 },
                    "nm": "Mask 1"
                }
            ],
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0.48, -0.63],
                                        [0.38, -1.72],
                                        [0.54, -1.94],
                                        [-0.06, -0.34],
                                        [0, 0],
                                        [0.458, -2.229],
                                        [0.1, -0.5],
                                        [-0.26, -1.22],
                                        [0, 0],
                                        [-0.511, 0.72],
                                        [-0.33, 1.51],
                                        [-0.31, 1.15],
                                        [-0.39, 0.75],
                                        [-0.01, 0.12],
                                        [-0.88, 3.15],
                                        [-0.15, 0.73],
                                        [0.37, 1.39]
                                    ],
                                    "o": [
                                        [-0.88, 1.14],
                                        [-0.14, 0.67],
                                        [-0.09, 0.32],
                                        [0.51, 2.96],
                                        [-0.01, 0.05],
                                        [-0.33, 1.69],
                                        [-0.28, 1.52],
                                        [0, 0],
                                        [0.18, 0.86],
                                        [0.71, -1.02],
                                        [0.19, -1.75],
                                        [0.39, -1.97],
                                        [0.06, -0.11],
                                        [0.05, -0.87],
                                        [0.45, -2.26],
                                        [0.32, -1.73],
                                        [-0.201, -0.76]
                                    ],
                                    "v": [
                                        [-30.037, -23.101],
                                        [-31.887, -19.021],
                                        [-33.627, -15.171],
                                        [-33.667, -14.181],
                                        [-34.167, -7.711],
                                        [-35.707, -0.151],
                                        [-36.297, 2.859],
                                        [-36.297, 6.829],
                                        [-36.307, 6.819],
                                        [-32.337, 7.62],
                                        [-30.797, 3.959],
                                        [-30.887, 0.499],
                                        [-28.527, -5.351],
                                        [-28.427, -5.701],
                                        [-27.247, -13.531],
                                        [-26.377, -17.921],
                                        [-26.497, -22.391]
                                    ],
                                    "c": true
                                }
                            },
                            "nm": "Path 3"
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.063, 0.071, 0.078, 1] },
                            "o": { "a": 0, "k": 100 },
                            "r": 1,
                            "nm": "Fill 1"
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [36.5, 23.369] },
                            "a": { "a": 0, "k": [0, 0] },
                            "s": { "a": 0, "k": [100, 100] },
                            "r": { "a": 0, "k": 0 },
                            "o": { "a": 0, "k": 100 },
                            "sk": { "a": 0, "k": 0 },
                            "sa": { "a": 0, "k": 0 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1"
                }
            ],
            "ip": 1,
            "op": 8,
            "st": 0
        },
        {
            "ind": 7,
            "ty": 3,
            "nm": "[Null] To-do Lozenge",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 0,
                            "s": [-9]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 3,
                            "s": [4]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 5,
                            "s": [0]
                        },
                        { "t": 16, "s": [0] }
                    ]
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 0,
                            "s": [-355, -78, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 3,
                            "s": [-337, -16, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 0.667 },
                            "o": { "x": 0.333, "y": 0.333 },
                            "t": 5,
                            "s": [-343, -28, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 0.667 },
                            "o": { "x": 0.333, "y": 0.333 },
                            "t": 7,
                            "s": [-343, -28, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 0.667 },
                            "o": { "x": 0.333, "y": 0.333 },
                            "t": 10,
                            "s": [-343, -28, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 0.667 },
                            "o": { "x": 0.333, "y": 0.333 },
                            "t": 13,
                            "s": [-343, -28, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 16,
                            "s": [-343, -28, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 20, "s": [-742, -28, 0] }
                    ],
                    "l": 2
                },
                "a": { "a": 0, "k": [50, 50, 0], "l": 2 },
                "s": { "a": 0, "k": [244, 108, 100], "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 8,
            "ty": 5,
            "nm": "TO DO",
            "parent": 7,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 13,
                            "s": [100]
                        },
                        { "t": 17, "s": [0] }
                    ]
                },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [44.721, 51.577, 0], "l": 2 },
                "a": { "a": 0, "k": [0.391, -23.281, 0], "l": 2 },
                "s": { "a": 0, "k": [40.984, 92.593, 100], "l": 2 }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 64,
                                "f": "AtlassianSans-Bold",
                                "t": "TO DO",
                                "ca": 0,
                                "j": 2,
                                "tr": -28,
                                "lh": 169,
                                "ls": 0,
                                "fc": [0, 0, 0]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": { "g": 1, "a": { "a": 0, "k": [0, 0] } },
                "a": []
            },
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 9,
            "ty": 4,
            "nm": "TO DO BG",
            "parent": 7,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 13,
                            "s": [100]
                        },
                        { "t": 17, "s": [0] }
                    ]
                },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [44.721, 51.577, 0], "l": 2 },
                "a": { "a": 0, "k": [-265.359, -17.484, 0], "l": 2 },
                "s": { "a": 0, "k": [40.984, 92.593, 100], "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "rc",
                            "d": 1,
                            "s": { "a": 0, "k": [250, 96] },
                            "p": { "a": 0, "k": [0, 0] },
                            "r": { "a": 0, "k": 12 },
                            "nm": "Rectangle Path 1"
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1] },
                            "o": { "a": 0, "k": 100 },
                            "w": { "a": 0, "k": 0 },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "nm": "Stroke 1"
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.867, 0.871, 0.882, 1] },
                            "o": { "a": 0, "k": 100 },
                            "r": 1,
                            "nm": "Fill 1"
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-265.359, -17.484] },
                            "a": { "a": 0, "k": [0, 0] },
                            "s": { "a": 0, "k": [100, 100] },
                            "r": { "a": 0, "k": 0 },
                            "o": { "a": 0, "k": 100 },
                            "sk": { "a": 0, "k": 0 },
                            "sa": { "a": 0, "k": 0 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Rectangle 1"
                }
            ],
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 10,
            "ty": 3,
            "nm": "[Null] In-progress Lozenge",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0 },
                "r": { "a": 0, "k": 0 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.649, "y": 0.649 },
                            "o": { "x": 0.333, "y": 0.333 },
                            "t": 7,
                            "s": [57, -28, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.646, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 14,
                            "s": [57, -28, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.646, "y": 1 },
                            "o": { "x": 0.167, "y": 0 },
                            "t": 20,
                            "s": [-342, -28, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.646, "y": 1 },
                            "o": { "x": 0.167, "y": 0 },
                            "t": 23,
                            "s": [-356, -28, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 25, "s": [-342, -28, 0] }
                    ],
                    "l": 2
                },
                "a": { "a": 0, "k": [50, 50, 0], "l": 2 },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                            "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                            "t": 34,
                            "s": [244, 108, 100]
                        },
                        { "t": 37, "s": [191, 84.541, 100] }
                    ],
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 11,
            "ty": 5,
            "nm": "IN PROGRESS",
            "parent": 10,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 15,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 16,
                            "s": [100]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 37,
                            "s": [100]
                        },
                        { "t": 38, "s": [0] }
                    ]
                },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [50.459, 50.651, 0], "l": 2 },
                "a": { "a": 0, "k": [0.391, -23.281, 0], "l": 2 },
                "s": { "a": 0, "k": [40.984, 92.593, 100], "l": 2 }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 64,
                                "f": "AtlassianSans-Bold",
                                "t": "IN PROGRESS",
                                "ca": 0,
                                "j": 2,
                                "tr": -28,
                                "lh": 169,
                                "ls": 0,
                                "fc": [0, 0, 0]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": { "g": 1, "a": { "a": 0, "k": [0, 0] } },
                "a": []
            },
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 12,
            "ty": 4,
            "nm": "IN PROGRESS BG",
            "parent": 10,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 15,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 16,
                            "s": [100]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 37,
                            "s": [100]
                        },
                        { "t": 38, "s": [0] }
                    ]
                },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [50.459, 50.651, 0], "l": 2 },
                "a": { "a": 0, "k": [-265.359, -17.484, 0], "l": 2 },
                "s": { "a": 0, "k": [40.984, 92.593, 100], "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "rc",
                            "d": 1,
                            "s": { "a": 0, "k": [490, 96] },
                            "p": { "a": 0, "k": [0, 0] },
                            "r": { "a": 0, "k": 12 },
                            "nm": "Rectangle Path 1"
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1] },
                            "o": { "a": 0, "k": 100 },
                            "w": { "a": 0, "k": 0 },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "nm": "Stroke 1"
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.561, 0.722, 0.965, 1] },
                            "o": { "a": 0, "k": 100 },
                            "r": 1,
                            "nm": "Fill 1"
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-265.359, -17.484] },
                            "a": { "a": 0, "k": [0, 0] },
                            "s": { "a": 0, "k": [100, 100] },
                            "r": { "a": 0, "k": 0 },
                            "o": { "a": 0, "k": 100 },
                            "sk": { "a": 0, "k": 0 },
                            "sa": { "a": 0, "k": 0 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Rectangle 1"
                }
            ],
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 13,
            "ty": 3,
            "nm": "[Null] Done Lozenge",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 37,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 40,
                            "s": [-4]
                        },
                        { "t": 47, "s": [0] }
                    ]
                },
                "p": { "a": 0, "k": [-343, -28, 0], "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "l": 2 },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                            "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                            "t": 37,
                            "s": [203.333, 90, 100]
                        },
                        {
                            "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                            "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                            "t": 40,
                            "s": [244, 108, 100]
                        },
                        { "t": 47, "s": [244, 108, 100] }
                    ],
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 14,
            "ty": 5,
            "nm": "DONE",
            "parent": 13,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 37,
                            "s": [0]
                        },
                        { "t": 38, "s": [100] }
                    ]
                },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [50.459, 50.651, 0], "l": 2 },
                "a": { "a": 0, "k": [0.391, -23.281, 0], "l": 2 },
                "s": { "a": 0, "k": [40.984, 92.593, 100], "l": 2 }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 64,
                                "f": "AtlassianSans-Bold",
                                "t": "DONE",
                                "ca": 0,
                                "j": 2,
                                "tr": -28,
                                "lh": 169,
                                "ls": 0,
                                "fc": [0, 0, 0]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": { "g": 1, "a": { "a": 0, "k": [0, 0] } },
                "a": []
            },
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 15,
            "ty": 4,
            "nm": "DONE BG",
            "parent": 13,
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.667], "y": [1] },
                            "o": { "x": [0.333], "y": [0] },
                            "t": 37,
                            "s": [0]
                        },
                        { "t": 38, "s": [100] }
                    ]
                },
                "r": { "a": 0, "k": 0 },
                "p": { "a": 0, "k": [50.459, 50.651, 0], "l": 2 },
                "a": { "a": 0, "k": [-265.359, -17.484, 0], "l": 2 },
                "s": { "a": 0, "k": [40.984, 92.593, 100], "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "rc",
                            "d": 1,
                            "s": { "a": 0, "k": [230, 96] },
                            "p": { "a": 0, "k": [0, 0] },
                            "r": { "a": 0, "k": 12 },
                            "nm": "Rectangle Path 1"
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1] },
                            "o": { "a": 0, "k": 100 },
                            "w": { "a": 0, "k": 0 },
                            "lc": 1,
                            "lj": 1,
                            "ml": 4,
                            "nm": "Stroke 1"
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [0.702, 0.875, 0.447, 1] },
                            "o": { "a": 0, "k": 100 },
                            "r": 1,
                            "nm": "Fill 1"
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-265.359, -17.484] },
                            "a": { "a": 0, "k": [0, 0] },
                            "s": { "a": 0, "k": [100, 100] },
                            "r": { "a": 0, "k": 0 },
                            "o": { "a": 0, "k": 100 },
                            "sk": { "a": 0, "k": 0 },
                            "sa": { "a": 0, "k": 0 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Rectangle 1"
                }
            ],
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 16,
            "ty": 5,
            "nm": "faster with Jira + Rovo",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100 },
                "r": { "a": 0, "k": 0 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.667, "y": 0.667 },
                            "o": { "x": 0.333, "y": 0.333 },
                            "t": 7,
                            "s": [274.338, 7.172, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 14,
                            "s": [274.338, 7.172, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 0.667 },
                            "o": { "x": 0.333, "y": 0.333 },
                            "t": 20,
                            "s": [405.338, 7.172, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 34,
                            "s": [405.338, 7.172, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 41, "s": [275.338, 7.172, 0] }
                    ],
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "l": 2 }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 96,
                                "f": "CharlieDisplay-Black",
                                "t": "faster with Jira + Rovo",
                                "ca": 0,
                                "j": 2,
                                "tr": -28,
                                "lh": 169,
                                "ls": 0,
                                "fc": [0, 0, 0]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": { "g": 1, "a": { "a": 0, "k": [0, 0] } },
                "a": []
            },
            "ip": 0,
            "op": 72,
            "st": 0
        },
        {
            "ind": 17,
            "ty": 5,
            "nm": "Get to",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100 },
                "r": { "a": 0, "k": 0 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.667, "y": 0.667 },
                            "o": { "x": 0.333, "y": 0.333 },
                            "t": 7,
                            "s": [-621.662, 7.172, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 14,
                            "s": [-621.662, 7.172, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 0.667 },
                            "o": { "x": 0.333, "y": 0.333 },
                            "t": 20,
                            "s": [-726.662, 7.172, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.667, "y": 1 },
                            "o": { "x": 0.333, "y": 0 },
                            "t": 34,
                            "s": [-726.662, 7.172, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 41, "s": [-597.662, 7.172, 0] }
                    ],
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "l": 2 }
            },
            "ao": 0,
            "t": {
                "d": {
                    "k": [
                        {
                            "s": {
                                "s": 96,
                                "f": "CharlieDisplay-Black",
                                "t": "Get to",
                                "ca": 0,
                                "j": 2,
                                "tr": -28,
                                "lh": 169,
                                "ls": 0,
                                "fc": [0, 0, 0]
                            },
                            "t": 0
                        }
                    ]
                },
                "p": {},
                "m": { "g": 1, "a": { "a": 0, "k": [0, 0] } },
                "a": []
            },
            "ip": 0,
            "op": 72,
            "st": 0
        }
    ],
    "markers": [],
    "chars": [
        {
            "ch": "G",
            "size": 96,
            "style": "Black",
            "w": 67.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-5.539, 3.424],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [1.108, 0],
                                            [0, 10.272],
                                            [-14.905, 0],
                                            [-6.042, -3.021],
                                            [0, 0],
                                            [6.445, 0],
                                            [0, -21.652],
                                            [-23.868, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-1.611, 0.101],
                                            [-13.394, 0],
                                            [0, -10.272],
                                            [5.539, 0],
                                            [0, 0],
                                            [-6.546, -3.223],
                                            [-24.673, 0],
                                            [0, 20.142],
                                            [8.157, 0]
                                        ],
                                        "v": [
                                            [63.245, -3.625],
                                            [63.245, -39.78],
                                            [34.946, -39.78],
                                            [34.946, -25.983],
                                            [45.621, -25.983],
                                            [45.621, -16.214],
                                            [41.492, -16.013],
                                            [22.256, -33.334],
                                            [43.103, -50.555],
                                            [62.54, -46.426],
                                            [62.54, -63.144],
                                            [41.19, -67.374],
                                            [2.014, -32.932],
                                            [38.672, 1.108]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "G"
                            }
                        ],
                        "nm": "G"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "e",
            "size": 96,
            "style": "Black",
            "w": 54,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-4.733, 0],
                                            [-0.504, -7.05],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [4.532, 0],
                                            [0, 0],
                                            [0.604, -6.747]
                                        ],
                                        "v": [
                                            [27.896, -40.082],
                                            [35.349, -29.91],
                                            [20.142, -29.91]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "e"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-4.935, 1.813],
                                            [0, 0],
                                            [6.042, 0],
                                            [1.208, 5.136],
                                            [0, 0],
                                            [0, 0],
                                            [17.12, 0],
                                            [0, -16.415],
                                            [-20.847, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [-5.338, 1.511],
                                            [-7.15, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, -16.516],
                                            [-17.322, 0],
                                            [0, 17.12],
                                            [6.747, 0]
                                        ],
                                        "v": [
                                            [50.455, -2.115],
                                            [50.455, -17.02],
                                            [32.428, -14.603],
                                            [20.544, -21.35],
                                            [52.368, -21.35],
                                            [52.368, -25.278],
                                            [28.198, -53.375],
                                            [1.813, -25.278],
                                            [32.025, 1.007]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "e"
                            }
                        ],
                        "nm": "e"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "t",
            "size": 96,
            "style": "Black",
            "w": 35.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 3.223],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-13.092, 0],
                                            [-2.618, 0.604],
                                            [0, 0],
                                            [1.511, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 11.279],
                                            [4.532, 0],
                                            [0, 0],
                                            [-1.108, 0.201],
                                            [-3.122, 0]
                                        ],
                                        "v": [
                                            [24.774, -20.847],
                                            [24.774, -36.758],
                                            [33.536, -36.758],
                                            [33.536, -52.167],
                                            [24.774, -52.167],
                                            [24.774, -62.741],
                                            [5.841, -62.741],
                                            [5.841, -52.167],
                                            [1.007, -52.167],
                                            [1.007, -36.758],
                                            [5.841, -36.758],
                                            [5.841, -18.228],
                                            [23.465, 0.806],
                                            [33.536, -0.302],
                                            [33.536, -16.516],
                                            [29.507, -16.013]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "t"
                            }
                        ],
                        "nm": "t"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": " ",
            "size": 96,
            "style": "Black",
            "w": 16.5,
            "data": {},
            "fFamily": "Charlie Display"
        },
        {
            "ch": "o",
            "size": 96,
            "style": "Black",
            "w": 56.1,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-16.818, 0],
                                            [0, 16.415],
                                            [16.617, 0],
                                            [0, -16.315]
                                        ],
                                        "o": [
                                            [16.617, 0],
                                            [0, -16.315],
                                            [-16.818, 0],
                                            [0, 16.415]
                                        ],
                                        "v": [
                                            [28.4, 1.309],
                                            [54.584, -26.184],
                                            [28.4, -53.375],
                                            [1.813, -26.184]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "o"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-5.539, 0],
                                            [0, -6.546],
                                            [5.237, 0],
                                            [0, 6.647]
                                        ],
                                        "o": [
                                            [5.237, 0],
                                            [0, 6.647],
                                            [-5.539, 0],
                                            [0, -6.546]
                                        ],
                                        "v": [
                                            [28.4, -37.061],
                                            [36.053, -26.184],
                                            [28.4, -14.905],
                                            [20.444, -26.184]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "o"
                            }
                        ],
                        "nm": "o"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "f",
            "size": 96,
            "style": "Black",
            "w": 36.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [-3.726, 0],
                                            [-1.309, -0.302],
                                            [0, 0],
                                            [2.618, 0],
                                            [0, -11.078],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, -2.921],
                                            [1.813, 0],
                                            [0, 0],
                                            [-2.417, -0.403],
                                            [-16.013, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [24.875, -54.785],
                                            [30.313, -59.72],
                                            [35.248, -59.216],
                                            [35.248, -72.308],
                                            [26.788, -73.114],
                                            [5.841, -54.584],
                                            [5.841, -52.167],
                                            [1.007, -52.167],
                                            [1.007, -36.758],
                                            [5.841, -36.758],
                                            [5.841, 0],
                                            [24.875, 0],
                                            [24.875, -36.758],
                                            [35.147, -36.758],
                                            [35.147, -52.167],
                                            [24.875, -52.167]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "f"
                            }
                        ],
                        "nm": "f"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "a",
            "size": 96,
            "style": "Black",
            "w": 56.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 7.352],
                                            [-4.834, 0],
                                            [0, -6.345],
                                            [0, 0],
                                            [3.726, 0]
                                        ],
                                        "o": [
                                            [0, -7.15],
                                            [3.827, 0],
                                            [0, 0],
                                            [0, 6.244],
                                            [-4.532, 0]
                                        ],
                                        "v": [
                                            [20.544, -26.083],
                                            [27.896, -37.262],
                                            [34.442, -28.198],
                                            [34.442, -24.069],
                                            [27.493, -15.106]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "a"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [6.848, 0],
                                            [0, -14.804],
                                            [-12.085, 0],
                                            [-3.021, 6.949]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-2.618, -5.942],
                                            [-12.891, 0],
                                            [0, 15.71],
                                            [6.546, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [34.442, 0],
                                            [53.476, 0],
                                            [53.476, -52.167],
                                            [34.442, -52.167],
                                            [34.442, -43.204],
                                            [20.242, -53.174],
                                            [1.813, -26.083],
                                            [19.437, 1.007],
                                            [34.442, -9.265]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "a"
                            }
                        ],
                        "nm": "a"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "s",
            "size": 96,
            "style": "Black",
            "w": 46.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 10.776],
                                            [15.509, 2.719],
                                            [0, 1.712],
                                            [-3.122, 0],
                                            [-7.05, -2.618],
                                            [0, 0],
                                            [7.755, 0],
                                            [0, -10.675],
                                            [-15.207, -2.417],
                                            [0, -1.813],
                                            [3.122, 0],
                                            [4.834, 2.316],
                                            [0, 0],
                                            [-8.661, 0]
                                        ],
                                        "o": [
                                            [0, -7.855],
                                            [-5.841, -1.108],
                                            [0, -1.611],
                                            [5.942, 0],
                                            [0, 0],
                                            [-4.431, -2.417],
                                            [-13.596, 0],
                                            [0, 8.057],
                                            [4.532, 1.007],
                                            [0, 1.611],
                                            [-6.949, 0],
                                            [0, 0],
                                            [4.33, 2.316],
                                            [15.61, 0]
                                        ],
                                        "v": [
                                            [44.916, -16.214],
                                            [25.681, -32.629],
                                            [18.53, -36.356],
                                            [23.163, -38.873],
                                            [42.902, -34.341],
                                            [42.902, -49.347],
                                            [23.465, -53.375],
                                            [2.014, -36.658],
                                            [21.552, -19.839],
                                            [27.795, -16.113],
                                            [22.961, -13.495],
                                            [2.82, -18.43],
                                            [2.82, -3.223],
                                            [23.062, 1.108]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "s"
                            }
                        ],
                        "nm": "s"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "r",
            "size": 96,
            "style": "Black",
            "w": 36.9,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [-10.172, -0.705],
                                            [0, 0],
                                            [2.719, -7.05],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, -6.747],
                                            [0, 0],
                                            [-6.848, -0.403],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [22.861, -25.278],
                                            [36.658, -33.334],
                                            [36.658, -52.872],
                                            [22.861, -42.297],
                                            [22.861, -52.167],
                                            [3.726, -52.167],
                                            [3.726, 0],
                                            [22.861, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "r"
                            }
                        ],
                        "nm": "r"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "w",
            "size": 96,
            "style": "Black",
            "w": 85.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [75.027, 0],
                                            [87.012, -52.167],
                                            [69.388, -52.167],
                                            [62.741, -12.085],
                                            [53.073, -52.167],
                                            [34.442, -52.167],
                                            [24.875, -12.286],
                                            [18.127, -52.167],
                                            [-0.504, -52.167],
                                            [11.481, 0],
                                            [35.147, 0],
                                            [39.679, -17.926],
                                            [42.7, -35.349],
                                            [45.621, -17.926],
                                            [50.052, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "w"
                            }
                        ],
                        "nm": "w"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "i",
            "size": 96,
            "style": "Black",
            "w": 26.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, -6.546],
                                            [-6.647, 0],
                                            [0, 6.647],
                                            [6.848, 0]
                                        ],
                                        "o": [
                                            [0, 6.647],
                                            [6.848, 0],
                                            [0, -6.546],
                                            [-6.647, 0]
                                        ],
                                        "v": [
                                            [1.611, -66.669],
                                            [13.193, -56.195],
                                            [24.875, -66.669],
                                            [13.193, -77.042]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "i"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [3.726, 0],
                                            [22.76, 0],
                                            [22.76, -52.167],
                                            [3.726, -52.167]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "i"
                            }
                        ],
                        "nm": "i"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "h",
            "size": 96,
            "style": "Black",
            "w": 56.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [10.977, 0],
                                            [2.82, -6.647],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-3.827, 0],
                                            [0, -4.733],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, -13.797],
                                            [-7.452, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, -5.841],
                                            [3.726, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [53.476, -31.723],
                                            [38.068, -53.275],
                                            [22.76, -42.801],
                                            [22.76, -71.402],
                                            [3.726, -71.402],
                                            [3.726, 0],
                                            [22.76, 0],
                                            [22.76, -29.004],
                                            [29.205, -37.463],
                                            [34.442, -30.414],
                                            [34.442, 0],
                                            [53.476, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "h"
                            }
                        ],
                        "nm": "h"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "J",
            "size": 96,
            "style": "Black",
            "w": 38,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [4.633, 0],
                                            [1.813, 0.604],
                                            [0, 0],
                                            [-4.733, 0],
                                            [0, 12.186],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 4.431],
                                            [-2.014, 0],
                                            [0, 0],
                                            [2.518, 0.906],
                                            [15.308, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [12.991, -25.58],
                                            [6.747, -18.228],
                                            [1.007, -19.235],
                                            [1.007, -1.309],
                                            [11.884, 0.403],
                                            [33.737, -20.142],
                                            [33.737, -66.165],
                                            [12.991, -66.165]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "J"
                            }
                        ],
                        "nm": "J"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "+",
            "size": 96,
            "style": "Black",
            "w": 49.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [16.214, -55.188],
                                            [16.214, -40.485],
                                            [2.316, -40.485],
                                            [2.316, -23.566],
                                            [16.214, -23.566],
                                            [16.214, -7.855],
                                            [33.636, -7.855],
                                            [33.636, -23.566],
                                            [47.635, -23.566],
                                            [47.635, -40.485],
                                            [33.636, -40.485],
                                            [33.636, -55.188]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "+"
                            }
                        ],
                        "nm": "+"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "R",
            "size": 96,
            "style": "Black",
            "w": 66.6,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, -4.431],
                                            [6.546, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [6.546, 0],
                                            [0, 4.834],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [33.737, -49.448],
                                            [42.599, -42.096],
                                            [33.737, -34.341],
                                            [25.681, -34.341],
                                            [25.681, -49.448]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "R"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 9.164],
                                            [17.322, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, -14.703],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [6.445, -3.827]
                                        ],
                                        "v": [
                                            [63.245, -42.297],
                                            [37.463, -66.165],
                                            [5.035, -66.165],
                                            [5.035, 0],
                                            [25.681, 0],
                                            [25.681, -19.135],
                                            [33.636, -19.135],
                                            [42.599, 0],
                                            [66.769, 0],
                                            [53.677, -22.76]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "R"
                            }
                        ],
                        "nm": "R"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "v",
            "size": 96,
            "style": "Black",
            "w": 52.2,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [39.578, 0],
                                            [53.275, -52.167],
                                            [35.147, -52.167],
                                            [26.587, -13.394],
                                            [18.027, -52.167],
                                            [-0.504, -52.167],
                                            [13.193, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "v"
                            }
                        ],
                        "nm": "v"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "A",
            "size": 96,
            "style": "Black",
            "w": 67.3,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-3.122, 0],
                                            [-3.525, 0.504],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [3.424, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [3.323, 0.504]
                                        ],
                                        "v": [
                                            [33.536, -11.078],
                                            [43.808, -11.884],
                                            [46.426, 0],
                                            [68.582, 0],
                                            [48.944, -66.165],
                                            [18.832, -66.165],
                                            [-0.906, 0],
                                            [21.249, 0],
                                            [23.868, -11.783]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "A"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [2.316, 0],
                                            [2.216, 0.201],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [-2.115, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-2.417, 0.302]
                                        ],
                                        "v": [
                                            [33.536, -25.681],
                                            [27.09, -25.983],
                                            [33.838, -56.094],
                                            [40.585, -26.083]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "A"
                            }
                        ],
                        "nm": "A"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "I",
            "size": 96,
            "style": "Black",
            "w": 30.4,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [4.935, -66.165],
                                            [4.935, 0],
                                            [25.681, 0],
                                            [25.681, -66.165]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "I"
                            }
                        ],
                        "nm": "I"
                    }
                ]
            },
            "fFamily": "Charlie Display"
        },
        {
            "ch": "D",
            "size": 64,
            "style": "Bold",
            "w": 72.22,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-5.29, 2.914],
                                            [-2.832, 5.437],
                                            [0, 7.585],
                                            [2.832, 5.42],
                                            [5.257, 2.914],
                                            [7.291, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-3.142, -1.66],
                                            [-1.611, -3.467],
                                            [0, -5.403],
                                            [1.595, -3.483],
                                            [3.174, -1.66],
                                            [4.688, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [5.289, -2.913],
                                            [2.832, -5.436],
                                            [0, -7.552],
                                            [-2.832, -5.42],
                                            [-5.257, -2.913],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [4.655, 0],
                                            [3.141, 1.66],
                                            [1.611, 3.467],
                                            [0, 5.437],
                                            [-1.595, 3.484],
                                            [-3.174, 1.66],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [7.389, 0]
                                        ],
                                        "v": [
                                            [51.196, -4.37],
                                            [63.379, -16.895],
                                            [67.627, -36.426],
                                            [63.379, -55.884],
                                            [51.245, -68.384],
                                            [32.422, -72.754],
                                            [12.988, -72.754],
                                            [12.988, -59.912],
                                            [31.543, -59.912],
                                            [43.237, -57.422],
                                            [50.366, -49.731],
                                            [52.783, -36.426],
                                            [50.391, -23.047],
                                            [43.237, -15.332],
                                            [31.445, -12.842],
                                            [13.33, -12.842],
                                            [13.33, 0],
                                            [32.178, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "D"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [6.592, -72.754],
                                            [6.592, 0],
                                            [21.484, 0],
                                            [21.484, -72.754]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "D"
                            }
                        ],
                        "nm": "D"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": "O",
            "size": 64,
            "style": "Bold",
            "w": 77.05,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-5.111, 2.93],
                                            [-2.979, 5.566],
                                            [0, 7.878],
                                            [2.979, 5.583],
                                            [5.11, 2.93],
                                            [6.445, 0],
                                            [5.127, -2.93],
                                            [2.979, -5.582],
                                            [0, -7.91],
                                            [-2.979, -5.566],
                                            [-5.127, -2.93],
                                            [-6.413, 0]
                                        ],
                                        "o": [
                                            [5.11, -2.93],
                                            [2.979, -5.566],
                                            [0, -7.91],
                                            [-2.979, -5.582],
                                            [-5.111, -2.93],
                                            [-6.413, 0],
                                            [-5.127, 2.93],
                                            [-2.979, 5.583],
                                            [0, 7.878],
                                            [2.979, 5.566],
                                            [5.127, 2.93],
                                            [6.445, 0]
                                        ],
                                        "v": [
                                            [55.859, -3.418],
                                            [67.993, -16.162],
                                            [72.461, -36.328],
                                            [67.993, -56.567],
                                            [55.859, -69.336],
                                            [38.525, -73.73],
                                            [21.216, -69.336],
                                            [9.058, -56.567],
                                            [4.59, -36.328],
                                            [9.058, -16.162],
                                            [21.216, -3.418],
                                            [38.525, 0.977]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "O"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [2.832, 1.855],
                                            [1.562, 3.581],
                                            [0, 5.176],
                                            [-1.562, 3.597],
                                            [-2.832, 1.855],
                                            [-3.744, 0],
                                            [-2.816, -1.839],
                                            [-1.562, -3.596],
                                            [0, -5.241],
                                            [1.562, -3.596],
                                            [2.815, -1.839],
                                            [3.776, 0]
                                        ],
                                        "o": [
                                            [-2.832, -1.855],
                                            [-1.562, -3.58],
                                            [0, -5.208],
                                            [1.562, -3.596],
                                            [2.832, -1.855],
                                            [3.776, 0],
                                            [2.815, 1.839],
                                            [1.562, 3.597],
                                            [0, 5.176],
                                            [-1.562, 3.597],
                                            [-2.816, 1.839],
                                            [-3.744, 0]
                                        ],
                                        "v": [
                                            [28.662, -15.039],
                                            [22.07, -23.193],
                                            [19.727, -36.328],
                                            [22.07, -49.536],
                                            [28.662, -57.715],
                                            [38.525, -60.498],
                                            [48.413, -57.739],
                                            [54.98, -49.585],
                                            [57.324, -36.328],
                                            [54.98, -23.169],
                                            [48.413, -15.015],
                                            [38.525, -12.256]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "O"
                            }
                        ],
                        "nm": "O"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": "N",
            "size": 64,
            "style": "Bold",
            "w": 76.22,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0.114, 2.621],
                                            [0.195, 3.223],
                                            [0.195, 3.516],
                                            [0, 0],
                                            [-1.416, -2.848],
                                            [-1.302, -2.36],
                                            [-1.53, -2.506],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-0.13, -2.799],
                                            [-0.179, -3.059],
                                            [-0.228, -2.702],
                                            [0, 0],
                                            [1.253, 2.702],
                                            [1.204, 2.214],
                                            [1.172, 1.888],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, -1.66],
                                            [-0.114, -2.62],
                                            [-0.195, -3.223],
                                            [0, 0],
                                            [1.953, 3.972],
                                            [1.416, 2.849],
                                            [1.302, 2.361],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 1.953],
                                            [0.13, 2.8],
                                            [0.179, 3.06],
                                            [0, 0],
                                            [-1.237, -3.385],
                                            [-1.254, -2.702],
                                            [-1.205, -2.213],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [21.826, 0],
                                            [21.826, -33.447],
                                            [21.655, -39.868],
                                            [21.191, -48.633],
                                            [20.605, -58.74],
                                            [18.701, -58.74],
                                            [23.755, -48.511],
                                            [27.832, -40.698],
                                            [32.08, -33.398],
                                            [52.979, 0],
                                            [69.629, 0],
                                            [69.629, -72.754],
                                            [54.395, -72.754],
                                            [54.395, -37.842],
                                            [54.59, -30.713],
                                            [55.054, -21.924],
                                            [55.664, -13.281],
                                            [57.178, -13.281],
                                            [53.442, -22.412],
                                            [49.756, -29.785],
                                            [46.191, -35.938],
                                            [23.193, -72.754],
                                            [6.592, -72.754],
                                            [6.592, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "N"
                            }
                        ],
                        "nm": "N"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": "E",
            "size": 64,
            "style": "Bold",
            "w": 60.74,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [55.371, 0],
                                            [55.371, -12.354],
                                            [21.484, -12.354],
                                            [21.484, -30.664],
                                            [52.734, -30.664],
                                            [52.734, -42.822],
                                            [21.484, -42.822],
                                            [21.484, -60.4],
                                            [55.273, -60.4],
                                            [55.273, -72.754],
                                            [6.592, -72.754],
                                            [6.592, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "E"
                            }
                        ],
                        "nm": "E"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": "I",
            "size": 64,
            "style": "Bold",
            "w": 47.66,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [44.043, 0],
                                            [44.043, -12.354],
                                            [31.299, -12.354],
                                            [31.299, -60.4],
                                            [44.043, -60.4],
                                            [44.043, -72.754],
                                            [3.613, -72.754],
                                            [3.613, -60.4],
                                            [16.357, -60.4],
                                            [16.357, -12.354],
                                            [3.613, -12.354],
                                            [3.613, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "I"
                            }
                        ],
                        "nm": "I"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": " ",
            "size": 64,
            "style": "Bold",
            "w": 23.68,
            "data": {},
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": "P",
            "size": 64,
            "style": "Bold",
            "w": 64.79,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-1.986, -1.025],
                                            [-0.961, -1.839],
                                            [0, -2.441],
                                            [0.96, -1.855],
                                            [1.969, -1.057],
                                            [3.059, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-3.923, 2.068],
                                            [-2.068, 3.662],
                                            [0, 4.818],
                                            [2.034, 3.695],
                                            [3.873, 2.1],
                                            [5.534, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [3.059, 0],
                                            [1.985, 1.025],
                                            [0.96, 1.839],
                                            [0, 2.441],
                                            [-0.961, 1.855],
                                            [-1.97, 1.058],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [5.598, 0],
                                            [3.922, -2.067],
                                            [2.067, -3.662],
                                            [0, -4.785],
                                            [-2.035, -3.694],
                                            [-3.874, -2.1],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [21.484, 0],
                                            [21.484, -60.449],
                                            [32.178, -60.449],
                                            [39.746, -58.911],
                                            [44.165, -54.614],
                                            [45.605, -48.193],
                                            [44.165, -41.748],
                                            [39.771, -37.378],
                                            [32.227, -35.791],
                                            [16.357, -35.791],
                                            [16.357, -23.779],
                                            [34.619, -23.779],
                                            [48.901, -26.88],
                                            [57.886, -35.474],
                                            [60.986, -48.193],
                                            [57.935, -60.913],
                                            [49.072, -69.604],
                                            [34.961, -72.754],
                                            [6.592, -72.754],
                                            [6.592, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "P"
                            }
                        ],
                        "nm": "P"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": "R",
            "size": 64,
            "style": "Bold",
            "w": 65.67,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-1.97, -0.879],
                                            [-0.977, -1.676],
                                            [0, -2.473],
                                            [0.977, -1.643],
                                            [1.953, -0.83],
                                            [3.059, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [-3.923, 1.839],
                                            [-2.068, 3.467],
                                            [0, 4.785],
                                            [2.034, 3.548],
                                            [3.873, 1.953],
                                            [5.534, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [3.059, 0],
                                            [1.969, 0.879],
                                            [0.977, 1.677],
                                            [0, 2.409],
                                            [-0.977, 1.644],
                                            [-1.953, 0.83],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [5.598, 0],
                                            [3.922, -1.839],
                                            [2.067, -3.467],
                                            [0, -4.785],
                                            [-2.035, -3.548],
                                            [-3.874, -1.953],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [21.484, 0],
                                            [21.484, -60.449],
                                            [32.178, -60.449],
                                            [39.722, -59.131],
                                            [44.141, -55.298],
                                            [45.605, -49.072],
                                            [44.141, -42.993],
                                            [39.746, -39.282],
                                            [32.227, -38.037],
                                            [15.381, -38.037],
                                            [15.381, -25.977],
                                            [34.619, -25.977],
                                            [48.901, -28.735],
                                            [57.886, -36.694],
                                            [60.986, -49.072],
                                            [57.935, -61.572],
                                            [49.072, -69.824],
                                            [34.961, -72.754],
                                            [6.592, -72.754],
                                            [6.592, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "R"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [63.574, 0],
                                            [45.508, -33.105],
                                            [29.346, -33.105],
                                            [47.07, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "R"
                            }
                        ],
                        "nm": "R"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": "G",
            "size": 64,
            "style": "Bold",
            "w": 75.98,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-2.8, 1.253],
                                            [-1.709, 2.181],
                                            [-0.781, 2.832],
                                            [0, 3.125],
                                            [0, 0],
                                            [0, 0],
                                            [1.334, -2.441],
                                            [2.49, -1.318],
                                            [3.483, 0],
                                            [2.897, 1.888],
                                            [1.595, 3.597],
                                            [0, 5.144],
                                            [-1.595, 3.581],
                                            [-2.865, 1.872],
                                            [-3.744, 0],
                                            [-1.693, -0.504],
                                            [-1.318, -0.977],
                                            [-0.928, -1.383],
                                            [-0.521, -1.758],
                                            [0, 0],
                                            [1.741, 2.979],
                                            [2.75, 2.181],
                                            [3.532, 1.189],
                                            [4.102, 0],
                                            [5.11, -2.962],
                                            [2.995, -5.582],
                                            [0, -7.877],
                                            [-2.881, -5.582],
                                            [-4.916, -3.011],
                                            [-6.12, 0]
                                        ],
                                        "o": [
                                            [2.799, -1.253],
                                            [1.709, -2.18],
                                            [0.781, -2.832],
                                            [0, 0],
                                            [0, 0],
                                            [0, 3.32],
                                            [-1.335, 2.441],
                                            [-2.49, 1.318],
                                            [-3.939, 0],
                                            [-2.898, -1.888],
                                            [-1.595, -3.596],
                                            [0, -5.143],
                                            [1.595, -3.58],
                                            [2.864, -1.871],
                                            [2.018, 0],
                                            [1.692, 0.505],
                                            [1.318, 0.977],
                                            [0.928, 1.384],
                                            [0, 0],
                                            [-0.521, -3.613],
                                            [-1.742, -2.979],
                                            [-2.751, -2.18],
                                            [-3.532, -1.188],
                                            [-6.38, 0],
                                            [-5.111, 2.962],
                                            [-2.995, 5.583],
                                            [0, 7.65],
                                            [2.881, 5.583],
                                            [4.915, 3.011],
                                            [4.036, 0]
                                        ],
                                        "v": [
                                            [47.412, -0.903],
                                            [54.175, -6.055],
                                            [57.91, -13.574],
                                            [59.082, -22.51],
                                            [59.082, -28.516],
                                            [55.811, -28.516],
                                            [53.809, -19.873],
                                            [48.071, -14.233],
                                            [39.111, -12.256],
                                            [28.857, -15.088],
                                            [22.119, -23.315],
                                            [19.727, -36.426],
                                            [22.119, -49.512],
                                            [28.809, -57.69],
                                            [38.721, -60.498],
                                            [44.287, -59.741],
                                            [48.804, -57.52],
                                            [52.173, -53.979],
                                            [54.346, -49.268],
                                            [69.482, -49.268],
                                            [66.089, -59.155],
                                            [59.351, -66.895],
                                            [49.927, -71.948],
                                            [38.477, -73.73],
                                            [21.24, -69.287],
                                            [9.082, -56.47],
                                            [4.59, -36.279],
                                            [8.911, -16.431],
                                            [20.605, -3.54],
                                            [37.158, 0.977]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "G"
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [70.215, 0],
                                            [70.215, -38.77],
                                            [39.941, -38.77],
                                            [39.941, -27.441],
                                            [58.35, -27.441],
                                            [58.35, -17.236],
                                            [60.303, 0]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "G"
                            }
                        ],
                        "nm": "G"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": "S",
            "size": 64,
            "style": "Bold",
            "w": 65.48,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [-4.199, 1.79],
                                            [-2.214, 3.271],
                                            [0, 4.395],
                                            [1.09, 2.344],
                                            [1.985, 1.709],
                                            [2.637, 1.172],
                                            [3.059, 0.684],
                                            [0, 0],
                                            [1.79, 0.732],
                                            [1.074, 1.189],
                                            [0, 1.791],
                                            [-0.928, 1.27],
                                            [-1.791, 0.716],
                                            [-2.507, 0],
                                            [-2.23, -1.595],
                                            [-0.261, -2.93],
                                            [0, 0],
                                            [2.246, 3.271],
                                            [4.004, 1.839],
                                            [5.371, 0],
                                            [4.118, -1.823],
                                            [2.36, -3.288],
                                            [0, -4.395],
                                            [-3.484, -3.206],
                                            [-6.152, -1.497],
                                            [0, 0],
                                            [-1.855, -0.813],
                                            [-0.993, -1.123],
                                            [0, -1.66],
                                            [1.106, -1.399],
                                            [1.969, -0.764],
                                            [2.669, 0],
                                            [2.116, 0.814],
                                            [1.27, 1.644],
                                            [0.195, 2.441],
                                            [0, 0],
                                            [-2.409, -3.516],
                                            [-4.314, -1.79],
                                            [-5.827, 0]
                                        ],
                                        "o": [
                                            [4.199, -1.79],
                                            [2.213, -3.271],
                                            [0, -3.059],
                                            [-1.091, -2.344],
                                            [-1.986, -1.709],
                                            [-2.637, -1.172],
                                            [0, 0],
                                            [-2.019, -0.488],
                                            [-1.791, -0.732],
                                            [-1.074, -1.188],
                                            [0, -1.627],
                                            [0.928, -1.27],
                                            [1.79, -0.716],
                                            [3.711, 0],
                                            [2.229, 1.595],
                                            [0, 0],
                                            [-0.066, -4.264],
                                            [-2.246, -3.271],
                                            [-4.004, -1.839],
                                            [-5.273, 0],
                                            [-4.118, 1.823],
                                            [-2.361, 3.288],
                                            [0, 5.273],
                                            [3.483, 3.207],
                                            [0, 0],
                                            [2.669, 0.619],
                                            [1.855, 0.814],
                                            [0.993, 1.123],
                                            [0, 1.855],
                                            [-1.107, 1.4],
                                            [-1.97, 0.765],
                                            [-2.67, 0],
                                            [-2.116, -0.813],
                                            [-1.27, -1.643],
                                            [0, 0],
                                            [0.13, 5.144],
                                            [2.409, 3.516],
                                            [4.313, 1.79],
                                            [5.891, 0]
                                        ],
                                        "v": [
                                            [48.389, -1.611],
                                            [58.008, -9.204],
                                            [61.328, -20.703],
                                            [59.692, -28.809],
                                            [55.078, -34.888],
                                            [48.145, -39.209],
                                            [39.6, -41.992],
                                            [33.008, -43.604],
                                            [27.295, -45.435],
                                            [22.998, -48.315],
                                            [21.387, -52.783],
                                            [22.778, -57.129],
                                            [26.855, -60.107],
                                            [33.301, -61.182],
                                            [42.212, -58.789],
                                            [45.947, -52.002],
                                            [60.352, -52.002],
                                            [56.885, -63.306],
                                            [47.51, -70.972],
                                            [33.447, -73.73],
                                            [19.36, -70.996],
                                            [9.644, -63.33],
                                            [6.104, -51.807],
                                            [11.328, -39.087],
                                            [25.781, -32.031],
                                            [33.789, -30.029],
                                            [40.576, -27.881],
                                            [44.849, -24.976],
                                            [46.338, -20.801],
                                            [44.678, -15.918],
                                            [40.063, -12.671],
                                            [33.105, -11.523],
                                            [25.928, -12.744],
                                            [20.85, -16.431],
                                            [18.652, -22.559],
                                            [4.15, -22.559],
                                            [7.959, -9.57],
                                            [18.042, -1.611],
                                            [33.252, 1.074]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "S"
                            }
                        ],
                        "nm": "S"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        },
        {
            "ch": "T",
            "size": 64,
            "style": "Bold",
            "w": 66.75,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "o": [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0]
                                        ],
                                        "v": [
                                            [25.928, -60.4],
                                            [25.928, 0],
                                            [40.869, 0],
                                            [40.869, -60.4],
                                            [63.086, -60.4],
                                            [63.086, -72.754],
                                            [3.662, -72.754],
                                            [3.662, -60.4]
                                        ],
                                        "c": true
                                    }
                                },
                                "nm": "T"
                            }
                        ],
                        "nm": "T"
                    }
                ]
            },
            "fFamily": "Atlassian Sans"
        }
    ]
}
